import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from '../../Image';
import type { ComponentProps } from 'react';
import { BodyText } from '../../Text';
import { HorizontalScrollRailHeader } from '../../HorizontalScrollRail/subcomponents';
import type { LoyaltyChallengeCardsRailProps } from '../LoyaltyChallengeCardsRail';

export const LoyaltyChallengesEmptyState = ({
  description,
  image,
  ...headerProps
}: LoyaltyChallengeCardsRailEmptyStateProps) => {
  return (
    <View>
      <HorizontalScrollRailHeader
        count={0}
        heading={headerProps.headerText}
        headerVariation={headerProps.headerVariation}
      />
      <View style={styles.wrapper}>
        <Image
          style={styles.image}
          source={image}
          accessibilityIgnoresInvertColors
          resizeMode="contain"
        />
        <BodyText size={3}>{description}</BodyText>
      </View>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 220,
    height: 130,
  },
});

// ─── TYPES ─────────────────────────────────────────────────────────────────

export type LoyaltyChallengeCardsRailEmptyStateProps = {
  readonly image: ComponentProps<typeof Image>['source'];
  readonly description: string;
} & Omit<
  LoyaltyChallengeCardsRailProps,
  'challenges' | 'emptyStateImage' | 'emptyStateDescription'
>;
